module.exports = __webpack_public_path__ + "static/media/14-wave_hand.9299706f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/14-wave_hand.png
// module id = 287
// module chunks = 0